<template>
  <div>
    <v-navigation-drawer
      :clipped="$vuetify.breakpoint.lgAndUp"
      :value="value"
      v-on:input="updateValue"
      fixed
      app
      id="nav-drawer"
      width="200"
    >
      <vue-perfect-scrollbar class="drawer-menu--scroll pl-2" :settings="scrollSettings">
        <v-list dense>
    <v-expansion-panel
      v-model="panel"
      expand
    >
      <v-expansion-panel-content
       v-for="(item,i) in items"
        :key="i"
      >
        <template v-slot:header>
          <div>{{ item.header }}</div>
        </template>
        <v-card>
          <v-list-tile v-for="(sub,j) in item.subMenu" 
        :key="j" :to="sub.to">
              <v-list-tile-action>
                <v-icon>{{ sub.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                    <v-list-tile-title v-bind="attrs" v-on="on">{{ sub.text }}</v-list-tile-title>
                  </template>
                  <span>{{ sub.text }}</span>
                </v-tooltip>
              </v-list-tile-content>
            </v-list-tile>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
        </v-list>
      </vue-perfect-scrollbar>
    </v-navigation-drawer>
    <v-toolbar :clipped-left="$vuetify.breakpoint.lgAndUp" color="blue darken-2" dark app fixed>
      <v-toolbar-title style="width: 500px" class="ml-0 pl-3">
        <v-toolbar-side-icon @click.stop="updateValue(!value)">
          <div class="v-btfn__content">
            <i aria-hidden="true" class="v-icon material-icons">menu</i>
          </div>
        </v-toolbar-side-icon>
        <span class="hidden-sm-and-down">
          <img style="height: 48px;margin-bottom: -14px;" src="@/assets/images/header-logo.png" />
          ERP Solutions
        </span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <div class="text-xs-center" v-if="roleName == 'ADMIN'">
        <v-chip color="primary" text-color="white" @click="changeOrderCount">
          <v-icon>shopping_cart</v-icon>
          <div
            v-if="orderCount > 0"
            style="border-radius: 50%;background-clip: padding-box;background: red;color: #fefefe;font: normal 0.85em 'Lato';height: 16px;line-height: 1.75em;position: absolute;right: 2px;text-align: center;top: -2px;width: 16px;"
          >{{ orderCount }}</div>
        </v-chip>
      </div>
      <div class="text-xs-center">
        <v-chip color="primary" text-color="white">{{ userName }}</v-chip>
      </div>
      <v-menu offset-y origin="center center" :nudge-bottom="10" transition="scale-transition">
        <v-btn icon large flat slot="activator">
          <v-icon large>account_circle</v-icon>
        </v-btn>
        <v-list class="pa-0">
          <v-list-tile>
            <v-list-tile-action>
              <v-icon>lock</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title @click="changePassword()">Change Password</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon>fullscreen_exit</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title @click="logout()">Logout</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import {
  AdminMenus,
  WarehouseManagerMenus,
  WarehouseStaffMenus,
  SaleManagerMenus,
  GeneralManagerMenus,
  SaleMenus,
  TopManagementMenus,
  AccountantMenus,
  FinanceManagerMenus,
  ProcurementManagerMenus,
  ProductionManagerMenus,
  BranchAdminMenus,
  AssetManagerMenus
} from "./menu";

export default {
  name: "NavigationDrawer",
  components: {
    VuePerfectScrollbar,
  },
  props: {
    value: Boolean,
    orderCount: Number,
  },
  data: () => ({
    scrollSettings: {
      maxScrollbarLength: 160,
    },
    panel:[false,false,false],
    dialog: false,
    adminMenus: AdminMenus,
    BranchAdminMenus: BranchAdminMenus,
    warehouseManagerMenus: WarehouseManagerMenus,
    warehouseStaffMenus: WarehouseStaffMenus,
    saleManagerMenus: SaleManagerMenus,
    generalManagerMenus : GeneralManagerMenus,
    saleMenus: SaleMenus,
    topManagementMenus: TopManagementMenus,
    finanaceManagerMenus: FinanceManagerMenus,
    accountantMenus: AccountantMenus,
    procurementManagerMenus: ProcurementManagerMenus,
    ProductionManagerMenus: ProductionManagerMenus,
    AssetManagerMenus: AssetManagerMenus,
    items: [],
    roleName: JSON.parse(localStorage.getItem("user")).roleName,
    userName: JSON.parse(localStorage.getItem("user")).username,
  }),
  created() {
    // control permission
    this.getMenuByPermission();
  },
  methods: {
    getMenuByPermission() {
      let user = JSON.parse(localStorage.getItem("user"));
      if (user.role.roleName == "ADMIN") {
        this.items = this.adminMenus;
      } else if (user.role.roleName == "TOP_MANAGEMENT") {
        this.items = this.topManagementMenus;
      } else if (user.role.roleName == "WAREHOUSE_MANAGER") {
        this.items = this.warehouseManagerMenus;
      } else if (user.role.roleName == "WAREHOUSE_STAFF") {
        this.items = this.warehouseStaffMenus;
      } else if (user.role.roleName == "SALE_MANAGER") {
        this.items = this.saleManagerMenus;
      }else if (user.role.roleName == "GENERAL_MANAGER") {
        this.items = this.generalManagerMenus;
      } else if (user.role.roleName == "SALE") {
        this.items = this.saleMenus;
      } else if (user.role.roleName == "FINANCE_MANAGER") {
        this.items = this.finanaceManagerMenus;
      } else if (user.role.roleName == "ACCOUNTANT") {
        this.items = this.accountantMenus;
      } else if (user.role.roleName == "PROCUREMENT_MANAGER") {
        this.items = this.procurementManagerMenus;
      }else if (user.role.roleName == "PRODUCTION_MANAGER") {
        this.items = this.ProductionManagerMenus;
      }else if (user.role.roleName == "BRANCH_ADMIN") {
        this.items = this.BranchAdminMenus;
      }else if (user.role.roleName == "ASSET_MANAGER") {
        this.items = this.AssetManagerMenus;
      }
    },
    logout() {
      this.$emit("clearTimer", true);
      localStorage.clear();
      window.history.go();
    },
    changePassword() {
      this.$router.push("/change-password");
    },
    updateValue(value) {
      this.$emit("input", value);
    },
    changeOrderCount() {
      this.$emit("changeOrderCount", true);
      this.$router.push("/orders");
    },
  },
};
</script>


<style lang="stylus">
#nav-drawer {
  overflow: hidden;

  .drawer-menu--scroll {
    height: calc(100vh - 48px);
    overflow: auto;
  }
}

.v-list__tile__title {
  cursor: pointer;
}

.v-navigation-drawer .v-list {
  margin-bottom: 30px;
}

.v-list__tile__action {
  min-width: 35px !important;
}
</style>
